export default __webpack_public_path__ + "static/media/videos_sel.43cf424c.svg";